import { render, staticRenderFns } from "./CupMap.vue?vue&type=template&id=5b372e7c&"
import script from "./CupMap.vue?vue&type=script&lang=js&"
export * from "./CupMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports